<!--加密货币行情-->
<template>
	<div class="page-body">

		<div class="title-div">{{ $t('加密货币行情') }}</div>

		<div class="base">
			<div class="item no-vw">
				<div class="title">{{ $t('涨幅排行') }}</div>
				<div class="list">
					<div class="list-item" v-for="item in zfRank" :key="item.id">
						<div class="coin">
							<img alt="" :src="item.image" class="lazy-img iconhtth">
							<div class="name">{{ item.symbol }}</div>
						</div>
						<div class="price">${{ item.price }}</div>
						<div class="percent" :class="{ green: item.price_zf >= 0 }">{{ item.price_zf >= 0 ? '+' : ''
							}}{{ item.price_zf }}%</div>
					</div>
				</div>
			</div>
			<div class="item no-vw">
				<div class="title">{{ $t('热门币种') }}</div>
				<div class="list">
					<div class="list-item" v-for="item in hotRank" :key="item.id">
						<div class="coin">
							<img alt="" :src="item.image" class="lazy-img iconhtth">
							<div class="name">{{ item.symbol }}</div>
						</div>
						<div class="price">${{ item.price }}</div>
						<div class="percent" :class="{ green: item.price_zf >= 0 }">{{ item.price_zf >= 0 ? '+' : ''
							}}{{ item.price_zf }}%</div>
					</div>
				</div>
			</div>
		</div>

		<listModel></listModel>
	</div>
</template>
<script>
import { get } from '@/http/request'
import listModel from './components/list.vue';
export default {
	components: {
		listModel
	},
	data() {
		return {
			hotRank: [],
			zfRank: []
		};
	},
	created() {
		get(this.$apis.getProductRank, { showLoading: false }).then(res => {
			if (res.code != 1) return
			this.hotRank = res.data.hotRank || []
			this.zfRank = res.data.zfRank || []
		})
	},
	methods: {
	},
};
</script>
<style lang="scss" scoped>
.page-body {
	padding: 62px 70px 109px;
	margin: 0 auto;
	color: #fff;

	.base {
		margin-top: 65px;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.item {
			width: calc(50% - 15px);
			padding: 26px 20px;
			border-radius: 12px;
			border: 2px solid #2c2c3e;

			.list {
				margin-top: 15px;
				display: flex;
				flex-flow: column wrap;
				align-items: flex-start;
				justify-content: flex-start;
				height: 130px;

				.list-item {
					width: calc(50% - 20px);
					margin: 9px 0;
					display: flex;
					align-items: center;
					justify-content: flex-start;

					.price,
					.percent {
						width: 33.333%;
						font-weight: 700;
						font-size: 15px;
						line-height: 22px;
						text-align: right;
					}

					.percent {
						color: #ff4834;
					}

					.coin {
						width: 33.333%;
						display: flex;
						justify-content: flex-start;
						align-items: center;

						.iconhtth {
							width: 24px;
							height: 24px;
							margin-right: 9px;
						}
					}
				}
			}

			.title {
				font-style: normal;
				font-weight: 700;
				font-size: 20px;
				line-height: 30px;
			}
		}
	}

	.title-div {
		height: 45px;
		font-style: normal;
		font-weight: 700;
		font-size: 30px;
		line-height: 45px;
	}

	.green {
		color: #00f0ff !important;
	}
}
</style>